/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TargetAttributoDefinizione } from './target-attributo-definizione';
import { UiWidget } from './ui-widget';
import { BindingTarget } from './binding-target';
import { TipoPraticaAttributoValoreDTO } from './tipo-pratica-attributo-valore-dto';
import { ValidationType } from './validation-type';


export interface TipoPraticaAttributoDTO { 
    id?: string;
    tipo_pratica_id?: string;
    target?: TargetAttributoDefinizione;
    chiave?: string;
    binding_target?: BindingTarget;
    ui_widget?: UiWidget;
    validation_type?: ValidationType;
    component_label?: string;
    component_description?: string;
    component_placeholder?: string;
    component_hint?: string;
    abilitato?: boolean;
    obbligatorio?: boolean;
    autofill?: boolean;
    ordine?: number;
    min_value?: string;
    max_value?: string;
    abilita_testo?: boolean;
    abilita_picker?: boolean;
    regex?: string;
    regex_error_message?: string;
    accept_file?: string;
    max_size_file_in_byte?: number;
    currency_symbol?: string;
    currency_decimal?: number;
    currency_thousands?: string;
    anno_isee?: number;
    chiave_origine_richiedente?: string;
    valori?: Array<TipoPraticaAttributoValoreDTO>;
    version?: number;
    created_at?: string;
    updated_at?: string;
}



